import { UserReviewLoading } from '../UserReview/UserReviewLoading'

export function ListLoading() {
  const reviewLoadings = []
  for (let i = 0; i < 7; i++) {
    reviewLoadings.push(<UserReviewLoading key={i} />)
  }

  return <>{reviewLoadings}</>
}
